export default __webpack_public_path__ + "static/media/cain12.1521917c.jpg";